import styles from './SimpleAppointmentCard.module.sass'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'

const SimpleAppointmentCard = ({ appointment }) => {
	const dateObj = appointment?.date?.date

	return (
		<div className={styles.card}>
			<div className={styles.item}>
				<Icon
					className={styles['text-icon']}
					name='leading'
					width='14px'
					height='14px'
				/>
				<strong>{appointment.medicalSpecialty?.name}</strong>
			</div>
			<div className={styles.item}>
				<Icon
					className={styles['text-icon']}
					name='location'
					width='14px'
					height='14px'
				/>
				<strong>{appointment.establishment?.name}</strong>
			</div>
			<div className={styles.item}>
				<Icon
					className={styles['text-icon']}
					name='calendar'
					width='14px'
					height='14px'
				/>
				<span>
					{dateObj instanceof Date
						? dateObj.toLocaleDateString('pt-PT')
						: 'Sem data'}
				</span>
			</div>
			<div className={styles.item}>
				<Icon
					className={styles['text-icon']}
					name='executed'
					width='14px'
					height='14px'
				/>
				<span>{appointment.status?.description}</span>
			</div>
		</div>
	)
}

export default SimpleAppointmentCard
